"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.typeDefs = exports.AnalyticsLocation = exports.Section = exports.SlateUtils = exports.Routes = exports.postDeletePermission = exports.postEditPermission = exports.postReadPermission = exports.taskDeletePermission = exports.taskEditPermission = exports.taskReadPermission = exports.questionDeletePermission = exports.questionEditPermission = exports.questionReadPermission = exports.commentDeletePermission = exports.commentEditPermission = exports.answerDeletePermission = exports.answerEditPermission = exports.answerReadPermission = exports.permissionSet = exports.Permission = exports.CommentUserRelationState = exports.AnswerUserRelationState = exports.QuestionUserRelationState = exports.PlexUserRelationState = exports.TaskUserRelationState = exports.PostUserRelationState = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
var PostUserRelationState_1 = require("./schema/PostUserRelationState");
Object.defineProperty(exports, "PostUserRelationState", { enumerable: true, get: function () { return PostUserRelationState_1.PostUserRelationState; } });
var TaskUserRelationState_1 = require("./schema/TaskUserRelationState");
Object.defineProperty(exports, "TaskUserRelationState", { enumerable: true, get: function () { return TaskUserRelationState_1.TaskUserRelationState; } });
var PlexUserRelationState_1 = require("./schema/PlexUserRelationState");
Object.defineProperty(exports, "PlexUserRelationState", { enumerable: true, get: function () { return PlexUserRelationState_1.PlexUserRelationState; } });
var QuestionUserRelationState_1 = require("./schema/QuestionUserRelationState");
Object.defineProperty(exports, "QuestionUserRelationState", { enumerable: true, get: function () { return QuestionUserRelationState_1.QuestionUserRelationState; } });
var AnswerUserRelationState_1 = require("./schema/AnswerUserRelationState");
Object.defineProperty(exports, "AnswerUserRelationState", { enumerable: true, get: function () { return AnswerUserRelationState_1.AnswerUserRelationState; } });
var CommentUserRelationState_1 = require("./schema/CommentUserRelationState");
Object.defineProperty(exports, "CommentUserRelationState", { enumerable: true, get: function () { return CommentUserRelationState_1.CommentUserRelationState; } });
var plex_1 = require("./permissions/plex");
Object.defineProperty(exports, "Permission", { enumerable: true, get: function () { return plex_1.Permission; } });
Object.defineProperty(exports, "permissionSet", { enumerable: true, get: function () { return plex_1.permissionSet; } });
var answer_1 = require("./permissions/answer");
Object.defineProperty(exports, "answerReadPermission", { enumerable: true, get: function () { return answer_1.answerReadPermission; } });
Object.defineProperty(exports, "answerEditPermission", { enumerable: true, get: function () { return answer_1.answerEditPermission; } });
Object.defineProperty(exports, "answerDeletePermission", { enumerable: true, get: function () { return answer_1.answerDeletePermission; } });
var comment_1 = require("./permissions/comment");
Object.defineProperty(exports, "commentEditPermission", { enumerable: true, get: function () { return comment_1.commentEditPermission; } });
Object.defineProperty(exports, "commentDeletePermission", { enumerable: true, get: function () { return comment_1.commentDeletePermission; } });
var question_1 = require("./permissions/question");
Object.defineProperty(exports, "questionReadPermission", { enumerable: true, get: function () { return question_1.questionReadPermission; } });
Object.defineProperty(exports, "questionEditPermission", { enumerable: true, get: function () { return question_1.questionEditPermission; } });
Object.defineProperty(exports, "questionDeletePermission", { enumerable: true, get: function () { return question_1.questionDeletePermission; } });
var task_1 = require("./permissions/task");
Object.defineProperty(exports, "taskReadPermission", { enumerable: true, get: function () { return task_1.taskReadPermission; } });
Object.defineProperty(exports, "taskEditPermission", { enumerable: true, get: function () { return task_1.taskEditPermission; } });
Object.defineProperty(exports, "taskDeletePermission", { enumerable: true, get: function () { return task_1.taskDeletePermission; } });
var post_1 = require("./permissions/post");
Object.defineProperty(exports, "postReadPermission", { enumerable: true, get: function () { return post_1.postReadPermission; } });
Object.defineProperty(exports, "postEditPermission", { enumerable: true, get: function () { return post_1.postEditPermission; } });
Object.defineProperty(exports, "postDeletePermission", { enumerable: true, get: function () { return post_1.postDeletePermission; } });
var routes_1 = require("./routes");
Object.defineProperty(exports, "Routes", { enumerable: true, get: function () { return routes_1.Routes; } });
var slate_utils_1 = require("./slate-utils");
Object.defineProperty(exports, "SlateUtils", { enumerable: true, get: function () { return slate_utils_1.SlateUtils; } });
Object.defineProperty(exports, "Section", { enumerable: true, get: function () { return slate_utils_1.Section; } });
var analytics_1 = require("./analytics");
Object.defineProperty(exports, "AnalyticsLocation", { enumerable: true, get: function () { return analytics_1.AnalyticsLocation; } });
exports.typeDefs = graphql_tag_1.default `
  scalar DateTime
  scalar SlateNode
  scalar PlexUserRelationState
  scalar QuestionUserRelationState
  scalar AnswerUserRelationState
  scalar PostUserRelationState
  scalar TaskUserRelationState

  type SlackChannel {
    id: String!
    name: String!
  }

  type SlackChannelResponse {
    results: [SlackChannel!]!
    nextCursor: String
  }

  type SearchPostBody {
    title: String
    body: String
    author: String
    createdAt: DateTime
    updatedAt: DateTime
    plexId: String
    publishStatus: PublishStatus
    postType: PostType
    permalink: String!
  }

  type SearchQuestionBody {
    text: String
    author: String
    createdAt: DateTime
    updatedAt: DateTime
    plexId: String
    questionStatus: QuestionStatus
    acceptedAnswerBody: String
    permalink: String!
  }

  union SearchResultBody = SearchPostBody | SearchQuestionBody

  enum SearchDocumentType {
    POST
    QUESTION
    EVENT
    MILESTONE
    TASK
  }

  input SearchFilters {
    plexIds: [String!]!
    types: [SearchDocumentType!]!
    labelIds: [String!]!
  }

  enum SearchSortOrder {
    SCORE
    CREATED_AT
    UPDATED_AT
  }

  type SearchResult {
    id: String!
    body: SearchResultBody!
  }

  type SearchResponse {
    nextCursor: String
    items: [SearchResult!]!
  }

  type Label {
    id: String!
    name: String!
  }

  type GoogleCalendar {
    id: String!
    internalId: String
    summary: String
    description: String
  }

  type GoogleCalendarEvent {
    id: String!
    summary: String
    description: String
    startTime: DateTime
    endTime: DateTime
    creator: String
    htmlLink: String
    isRecurring: Boolean
  }

  type GoogleCalendarEventsResponse {
    events: [GoogleCalendarEvent!]!
    nextCursor: String
  }

  enum UserStatus {
    ACTIVE
    INVITED
    DISABLED
  }

  type User {
    id: String!
    name: String!
    givenName: String
    familyName: String
    picture: String!
    email: String!
    locale: String!
    completedOnboardingSteps: [OnboardingStep!]!
    defaultStatus: String!
    timeZone: String
    language: LanguageEnum
    displayFilter: Boolean
    feedDisplay: Boolean
    displayTimeline: Boolean
    baseDisplay: Boolean
    jobTitle: String
    jobDepartment: DepartmentEnum
    accessControl: AccessControlEnum
    hasExtraGSuiteScopes: Boolean
    status: UserStatus!

    googleCalendars: [GoogleCalendar!]
    googleCalendarEvents(
      calendarId: String!
      query: String
      cursor: String
      startTimeMax: DateTime
      startTimeMin: DateTime
      limit: Int = 10
    ): GoogleCalendarEventsResponse

    domain: Domain
    plexes: [Plex!]
  }

  enum LanguageEnum {
    EN
  }

  enum IndustryEnum {
    TECHNOLOGY
  }

  enum DepartmentEnum {
    PRODUCT
    SALES
    MARKETING
    CUSTOMER_SUCCESS
    ENGINEERING
    OPERATIONS
    FINANCE
    LEGAL
  }

  enum AccessControlEnum {
    USER
    DOMAIN_ADMIN
  }

  input DomainInput {
    orgName: String
    industry: IndustryEnum
    email: String
    address: String
    authorizedDomain: Boolean
    picture: String
    resetSlackIntegration: Boolean
  }

  input UserSettingsInput {
    name: String
    picture: String
    jobTitle: String
    jobDepartment: DepartmentEnum
    resetOnboardingSteps: Boolean
    completedOnboardingStep: OnboardingStep
    defaultStatus: String
    timeZone: String
    language: LanguageEnum
    displayFilter: Boolean
    feedDisplay: Boolean
    displayTimeline: Boolean
    baseDisplay: Boolean
    domain: DomainInput
  }

  type SlackWorkspace {
    id: String
    name: String
    slackId: String
  }

  type PaymentInformation {
    id: String!
    cardholderName: String!
    cardBrand: String!
    cardLastFourDigits: String!
    cardExpiration: String!
    billingEmail: String!
    billingAddress: String!
  }

  enum SubscriptionStatus {
    TRIALING
    ACTIVE
    PAST_DUE
    UNPAID
    UNKNOWN
  }

  type SubscriptionInformation {
    id: String!
    numberOfSeats: Int!
    status: SubscriptionStatus!
    trialEnd: DateTime
    currentPeriodEnd: DateTime
  }

  type DomainUsersResponse {
    nextCursor: String
    users: [PlexRegisteredUser!]!
  }

  type Domain {
    id: String!
    plexes(cursor: String, limit: Int = 10): PlexesResponse
    slackChannels(cursor: String, limit: Int = 10): SlackChannelResponse
    search(
      query: String!
      cursor: String
      limit: Int = 10
      filters: SearchFilters!
      sortOrder: SearchSortOrder = SCORE
    ): SearchResponse
    url: String
    orgName: String
    industry: IndustryEnum
    email: String
    address: String
    authorizedDomain: Boolean
    picture: String
    slackWorkspace: SlackWorkspace
    paymentInformation: PaymentInformation
    isBillingCurrent: Boolean
    subscriptionInformation: SubscriptionInformation
    users(limit: Int = 50, cursor: String): DomainUsersResponse!
  }

  type PlexRegisteredUser {
    id: String!
    email: String!
    name: String!
    picture: String!
    jobTitle: String
    status: UserStatus
    accessControl: AccessControlEnum
  }

  type PlexInvitedUser {
    email: String!
  }

  union PlexMemberUser = PlexRegisteredUser | PlexInvitedUser

  enum PlexMemberRole {
    OWNER
    MANAGER
    WRITER
    READER
  }

  type PlexMember {
    user: PlexMemberUser!
    role: PlexMemberRole!
  }

  type PublicPlexMember {
    name: String!
    picture: String!
    role: PlexMemberRole!
  }

  enum PlexType {
    PROJECT
    PRODUCT
    CUSTOMER
  }

  type PlexSettings {
    members: [PlexMember!]!
    type: PlexType!
  }

  type PlexUserRelation {
    id: String!
    role: PlexMemberRole
    state: PlexUserRelationState!
  }

  type PlexQuestionTemplate {
    id: String!
    plexId: String!
    questionTemplateId: String!
    text: String!
    question: Question
  }

  enum ChannelType {
    GMAIL
    SLACK
  }

  type Channel {
    id: String!
    type: ChannelType!
    externalId: String!
    name: String
    deleted: Boolean
  }

  type PlexGoogleCalendar {
    id: String!
    googleCalendarId: String!
    summary: String
    description: String
  }

  type PlexSummary {
    id: String!
    members: [PublicPlexMember!]!
    channelsCount: Int!
    postsCount: Int!
    faqsCount: Int!
    events: [ChangeEvent!]!
  }

  type Plex {
    id: String!
    permalink: String!
    name: String!
    domainId: String
    description: String
    color: String
    currentUserRelation: PlexUserRelation!
    settings: PlexSettings!
    summary: PlexSummary!
    deleted: Boolean
    notifications: PlexNotification!
    defaultBoardId: String!

    questionTemplates: [PlexQuestionTemplate!]
    channels: [Channel!]
    googleCalendars: [PlexGoogleCalendar!]!
    boards: [Board!]!
    analytics: AnalyticsSummary!
  }

  enum FilterPublishStatus {
    DRAFT
    INTERNAL
    PUBLISHED
    ALL
  }

  enum PublishStatus {
    DRAFT
    INTERNAL
    PUBLISHED
  }

  enum VisibilityStatus {
    DRAFT
    INTERNAL
    PUBLIC
  }

  enum ReactionType {
    LIKE
    VOTE
    ANALYTICS_CLICK
    ANALYTICS_IMPRESSION
  }

  type ReactionCount {
    type: ReactionType!
    count: Int!
  }

  enum CommentType {
    FEEDBACK
    QUESTION
  }

  type Comment {
    id: String!
    type: CommentType!
    body: [SlateNode!]!
    postId: String
    questionId: String
    commenter: PlexRegisteredUser!
    createdAt: DateTime!
    currentUserReactions: [ReactionType!]!
    reactionCounts: [ReactionCount!]!
    externalSource: ChannelType
    deleted: Boolean
    post: Post
    question: Question

    links: [LinkMetadata!]!
    mentions: [PlexRegisteredUser!]!
  }

  type CommentReaction {
    id: String!
    type: ReactionType!
    reactingUser: PlexRegisteredUser!
    createdAt: DateTime!
  }

  enum PostType {
    POST
    EVENT
    MILESTONE
    TASK
  }

  enum FeedItemType {
    POST
    QUESTION
    PLEX
  }

  type FeedItemAnalytics {
    parentId: String!
    parentType: FeedItemType!
    plexId: String!

    audienceBy: [UserWithTimestamp!]!
    impressionsBy: [UserWithTimestamp!]!
    clicksBy: [UserWithTimestamp!]!

    audience: Int!
    impressions: Int!
    clicks: Int!
    commentsCount: Int!
    reactionsCount: Int!
  }

  type UserWithTimestamp {
    user: User!
    atDate: DateTime!
  }

  type GoogleDocumentSource {
    externalEntityId: String!
    url: String!
    headingIds: [String!]!
  }

  union DocumentSource = GoogleDocumentSource

  type Post {
    id: String!
    permalink: String!
    type: PostType!
    author: PlexRegisteredUser!
    currentUserRelation: PostUserRelationState!
    plexId: String!
    plex: Plex!
    publishStatus: PublishStatus!
    title: String!
    body: [SlateNode!]!
    commentsCount: Int!
    comments: [Comment!]!
    publishedDate: DateTime!
    primaryLinkId: String
    primaryLink: LinkMetadata
    picture: String
    eventDate: DateTime!
    deleted: Boolean
    currentUserReactions: [ReactionType!]!
    reactionCounts: [ReactionCount!]!
    labels: [Label!]!
    notification: PostNotification!
    watching: Boolean

    links: [LinkMetadata!]!
    mentions: [PlexRegisteredUser!]!
    analytics: FeedItemAnalytics

    source: DocumentSource
  }

  enum TaskStatus {
    OPEN
    IN_PROGRESS
    DONE
  }

  enum TaskType {
    TASK
    MILESTONE
  }

  type Task {
    id: String!
    permalink: String!
    type: TaskType!
    status: TaskStatus!
    publishStatus: PublishStatus!
    plexId: String!
    plex: Plex!
    author: PlexRegisteredUser!
    assignee: PlexRegisteredUser
    title: String!
    body: [SlateNode!]!
    links: [LinkMetadata!]!
    mentions: [PlexRegisteredUser!]!
    dueDate: DateTime
    createdAt: DateTime!
    deleted: Boolean!
    currentUserRelation: TaskUserRelationState!
    relatedEntities: [EntityRelation!]!
    postContainerId: String
    postContainer: Post
    labels: [Label!]!
  }

  enum EntityType {
    TASK
    EVENT
    FACT_REVIEW_PROCESS
  }

  enum EntityRelationType {
    DEPENDS_ON
    DEPENDENCY_OF
    CREATED_VIA
  }

  input EntityRelationInput {
    sourceType: EntityType!
    sourceId: String!
    type: EntityRelationType!
    targetType: EntityType!
    targetId: String!
  }

  union RelatableEntity = Task | FactReviewProcess

  type EntityRelation {
    id: String!
    sourceType: EntityType!
    sourceId: String!
    source: RelatableEntity
    type: EntityRelationType!
    targetType: EntityType!
    targetId: String!
    target: RelatableEntity
    deleted: Boolean!
  }

  type PlexesResponse {
    nextCursor: String
    items: [Plex!]!
  }

  type PostsResponse {
    nextCursor: String
    items: [Post!]!
  }

  type TasksResponse {
    nextCursor: String
    items: [Task!]!
  }

  enum UserSource {
    DIRECTORY
    CONTACTS
    GROUPS
    SLACK
    PLEX
  }

  type SearchUser {
    id: String!
    plexUserId: String
    name: String
    email: String!
    picture: String
    source: UserSource!
  }

  type SearchUsersResponse {
    results: [SearchUser!]!
  }

  type Answer {
    id: String!
    body: [SlateNode!]!
    publishedAt: DateTime!
    user: PlexRegisteredUser!
    currentUserReactions: [ReactionType!]!
    currentUserRelation: AnswerUserRelationState!
    reactionCounts: [ReactionCount!]!

    questionId: String!
    question: Question!

    primaryLinkId: String
    primaryLink: LinkMetadata
    links: [LinkMetadata!]!
    mentions: [PlexRegisteredUser!]!

    deleted: Boolean!
  }

  enum QuestionStatus {
    IGNORED
    DRAFT
    INTERNAL
    PUBLISHED
  }

  type QuestionPosition {
    id: String!
    positionInBoard: Int!
  }

  type QuestionPositionUpdate {
    boardId: String!
    plexId: String!
    positions: [QuestionPosition!]!
  }

  type BoardPosition {
    id: String!
    positionInPlex: Int!
  }

  type BoardPositionUpdate {
    updatedPositions: [BoardPosition!]!
  }

  enum CardType {
    GENERIC
    FAQ
  }

  type Question {
    id: String!
    permalink: String!
    text: String!
    status: QuestionStatus!
    deleted: Boolean!
    createdAt: DateTime!
    publishChangedAt: DateTime!
    author: PlexRegisteredUser
    type: CardType!

    plexId: String!
    plex: Plex!

    templateId: String
    template: PlexQuestionTemplate

    acceptedAnswerId: String
    acceptedAnswer: Answer

    answers: [Answer!]!
    answersCount: Int!
    comments: [Comment!]!
    commentsCount: Int!

    # TODO: currentUserRelation { id, watched, saved, viewed, upvoted }
    currentUserRelation: QuestionUserRelationState!

    reactionCounts: [ReactionCount!]!
    currentUserReactions: [ReactionType!]!
    labels: [Label!]!
    notification: FaqNotification!
    watching: Boolean
    positionInBoard: QuestionPosition!

    boardId: String!
    board: Board!
    analytics: FeedItemAnalytics

    source: DocumentSource
  }

  type QuestionsInBoard {
    boardId: String!
    questions: [Question!]!
    board: Board!
    nextCursor: String
    totalFaqCount: Int!
  }

  type FetchQuestionsResponse {
    items: [Question!]!
    nextCursor: Int
  }

  type Board {
    id: String!
    name: String!
    description: String!
    plexId: String!
    position: BoardPosition!
    plex: Plex!
    faqCount(filterPublishStatus: FilterPublishStatus!, labelIds: [String!]!): Int!
    deleted: Boolean!
    questions(
      cursor: Int
      limit: Int = 4
      filterPublishStatus: FilterPublishStatus!
      labelIds: [String!]!
    ): FetchQuestionsResponse!

    source: DocumentSource
  }

  type FeedBoardsResponse {
    items: [Board!]!
    nextCursor: Int
  }

  type ShareResponse {
    id: String!
    sharedDate: DateTime!
  }

  type GoogleDoc {
    id: String!
    title: String!
    content: [SlateNode!]!
  }

  type GoogleDriveFileMetadata {
    externalEntityId: String!
    title: String!
    mimeType: String!
    extension: String!
  }

  # Link metadata

  type PlexPostLinkMetadata {
    postId: String!
    post: Post
  }

  type PlexFactLinkMetadata {
    factId: String!
    fact: Question
  }

  type ImageLinkMetadata {
    url: String!
  }

  type AttachmentLinkMetadata {
    url: String!
    extension: String!
  }

  enum GoogleDocErrorCode {
    ACCESS_DENIED
    DOCUMENT_CONTENT_PARSE_FAILED
    GOOGLE_DOCS_CONNECTION_NOT_ENABLED
  }

  type GoogleDocError {
    code: GoogleDocErrorCode!
  }

  union GoogleDocResponse = GoogleDocError | GoogleDoc

  type GoogleDocLinkMetadata {
    fileId: String!
    headingId: String
    bookmarkId: String
    fileMetadata: GoogleDriveFileMetadata
    document: GoogleDocResponse
  }

  type GoogleSheetsLinkMetadata {
    fileId: String!
    fileMetadata: GoogleDriveFileMetadata
  }

  type GoogleSlidesLinkMetadata {
    fileId: String!
    fileMetadata: GoogleDriveFileMetadata
  }

  type GoogleDriveFileLinkMetadata {
    fileId: String!
    fileMetadata: GoogleDriveFileMetadata
  }

  type LinkMetadata {
    id: String!
    details: LinkMetadataDetails!
  }

  type GenericLink {
    url: String!
  }

  type InvalidLink {
    url: String!
  }

  union LinkMetadataDetails =
      PlexPostLinkMetadata
    | PlexFactLinkMetadata
    | ImageLinkMetadata
    | AttachmentLinkMetadata
    | GoogleDocLinkMetadata
    | GoogleDriveFileLinkMetadata
    | GoogleSheetsLinkMetadata
    | GoogleSlidesLinkMetadata
    | GenericLink
    | InvalidLink

  # Post Filters

  input PostFilters {
    plexIds: [String!]!
    types: [PostType!]!
    publishStatuses: [PublishStatus!]!
    before: DateTime
    onOrAfter: DateTime
    labelIds: [String!]!
  }

  enum UserTaskRelation {
    ASSIGNED_TO_ME
    CREATED_BY_ME
  }

  input TaskFilters {
    plexIds: [String!]!
    types: [TaskType!]!
    publishStatuses: [PublishStatus!]!
    labelIds: [String!]!
    userTaskRelation: UserTaskRelation
  }

  enum TimeOrder {
    ASC
    DESC
  }

  enum TasksOrder {
    CREATED_AT_DESC
    CREATED_AT_ASC
    DUE_DATE_DESC
    DUE_DATE_ASC
    STATUS_DESC
    STATUS_ASC
  }

  type LoggedInQuery {
    feedBoards(cursor: Int, limit: Int! = 4, plexIds: [String!]!): FeedBoardsResponse
    questionById(id: String!): Question
    plexById(id: String!): Plex
    boardById(id: String!): Board
    factAnswerById(id: String!): Answer
    labels: [Label!]
    postById(postId: String!): Post
    plexes(cursor: String, limit: Int = 10, ids: [String!]): PlexesResponse
    searchUsers(searchQuery: String, onlySignedUpUsers: Boolean): SearchUsersResponse
    notifications: [FeedNotification!]
    notificationsActivity(cursor: Int, limit: Int! = 10): NotificationsActivityResponse
    notificationsActivityUnreadCount: Int
    stripePublicKey: String
    commentById(id: String!): Comment
  }

  type QuestionTemplate {
    id: String!
    text: String!
  }

  type BoardTemplate {
    id: String!
    name: String!
    type: PlexType!
    templates: [QuestionTemplate!]!
  }

  type Query {
    currentUser: User
    loggedIn: LoggedInQuery
    linkMetadata(url: String!): LinkMetadata!
    posts(cursor: String, limit: Int = 10, timeOrder: TimeOrder!, filters: PostFilters!): PostsResponse!
    tasks(cursor: String, limit: Int = 10, filters: TaskFilters!, order: TasksOrder!): TasksResponse!
    taskById(taskId: String!): Task!
    boardTemplates: [BoardTemplate!]!
    factReviewProcessById(id: String!): FactReviewProcess!
  }

  type PlexNotification {
    id: String!
    count: Int!
  }

  type PostNotification {
    id: String!
    isRead: Boolean!
  }

  type FaqNotification {
    id: String!
    isRead: Boolean!
  }

  union FeedNotification = FaqNotification | PostNotification | PlexNotification

  type NotificationSubscriptionPayload {
    notifications: [FeedNotification!]!
    userId: String!
  }

  type ChangeEventTargetBoard {
    board: Board!
  }
  type ChangeEventTargetPost {
    post: Post!
  }
  type ChangeEventTargetEvent {
    event: Post!
  }
  type ChangeEventTargetQuestion {
    question: Question!
  }
  type ChangeEventTargetComment {
    comment: Comment!
  }
  type ChangeEventTargetAnswer {
    answer: Answer!
  }

  type ChangeEventTargetUnavailable {
    reason: String!
  }

  union ChangeEventTarget =
      ChangeEventTargetBoard
    | ChangeEventTargetPost
    | ChangeEventTargetEvent
    | ChangeEventTargetQuestion
    | ChangeEventTargetComment
    | ChangeEventTargetAnswer
    | ChangeEventTargetUnavailable

  type ChangeEventDeltaAnswer {
    mentions: [String]
  }

  type ChangeEventDeltaPost {
    publishStatus: PublishStatus
    title: String
    primaryLink: String
    mentions: [String]
  }

  type ChangeEventDeltaQuestion {
    text: String
    status: QuestionStatus
    acceptedAnswerId: String
  }

  type ChangeEventDeltaV1 {
    post: ChangeEventDeltaPost
    question: ChangeEventDeltaQuestion
    answer: ChangeEventDeltaAnswer
  }

  type ChangeEventDelta {
    v1: ChangeEventDeltaV1
  }

  type ChangeEvent {
    id: String!
    plexId: String!
    author: User!
    eventType: ChangeEventType!
    targetType: ChangeEventTargetType!
    targetId: String!
    eventTarget: ChangeEventTarget!
    createdAt: DateTime!
    plex: Plex!
    updateDeltaBefore: ChangeEventDelta
    updateDeltaAfter: ChangeEventDelta
  }

  type NotificationActivity {
    id: String!
    userId: String!
    event: ChangeEvent!
    isRead: Boolean!
    deleted: Boolean!
    totalUnreadCount: Int!
  }

  type NotificationsActivityResponse {
    items: [NotificationActivity!]!
    nextCursor: Int
  }

  type AnalyticsSummary {
    audience(plexId: String!): Int!
    impressions(plexId: String!): Int!
    clicks(plexId: String!): Int!
    commentsCount(plexId: String!): Int!
    reactionsCount(plexId: String!): Int!
    items(
      plexId: String!
      targetType: AnalyticsItemType!
      cursor: Int
      limit: Int!
      timeOrder: TimeOrder!
    ): AnalyticsItems!
  }

  type AnalyticsItems {
    posts: AnalyticsPosts!
    questions: AnalyticsQuestions!
  }

  type AnalyticsPosts {
    nextCursor: Int
    items: [Post!]!
  }

  type AnalyticsQuestions {
    nextCursor: Int
    items: [Question!]!
  }

  enum AnalyticsItemType {
    POST
    QUESTION
    ALL
  }

  enum PlexMemberInputType {
    EMAIL
    PLEX_USER_ID
  }

  input PlexMemberInput {
    role: PlexMemberRole!
    type: PlexMemberInputType!
    id: String!
  }

  type PlexMemberInputError {
    type: PlexMemberInputType!
    id: String!
    message: String!
  }

  type PlexInputError {
    addedMembers: [PlexMemberInputError!]!
  }

  input ChannelInput {
    id: String
    type: ChannelType!
    externalId: String!
    name: String
  }

  input GoogleCalendarInput {
    id: String
    googleCalendarId: String!
  }

  input PlexInput {
    name: String!
    color: String
    description: String
    addedMembers: [PlexMemberInput!]!
    removedMembers: [PlexMemberInput!]!
    channels: [ChannelInput!]
    googleCalendars: [GoogleCalendarInput!]
  }

  input PostSourceInput {
    externalEntityId: String!
    headingIds: [String!]!
  }

  input CreatePostInput {
    plexId: String!

    publishStatus: PublishStatus!
    title: String!
    body: [SlateNode!]!
    primaryLinkId: String
    picture: String
    labelIds: [String!]!

    source: PostSourceInput
  }

  input UpdatePostInput {
    id: String!

    publishStatus: PublishStatus!
    title: String!
    body: [SlateNode!]!
    primaryLinkId: String
    picture: String
    labelIds: [String!]!

    source: PostSourceInput
  }

  input CreateEventInput {
    plexId: String!

    publishStatus: PublishStatus!
    title: String!
    body: [SlateNode!]!
    primaryLinkId: String
    picture: String
    labelIds: [String!]!
    eventDate: DateTime!

    googleCalendarId: String
    googleCalendarEventId: String
  }

  input GoogleCalendarEventInput {
    plexId: String!
    calendarId: String!
    eventId: String!
  }

  input UpdateEventInput {
    id: String!

    publishStatus: PublishStatus!
    title: String!
    body: [SlateNode!]!
    primaryLinkId: String
    picture: String
    labelIds: [String!]!
    eventDate: DateTime!
  }

  input CreatePostCommentInput {
    postId: String!
    type: CommentType!
    body: [SlateNode!]!
  }

  input CreateQuestionCommentInput {
    questionId: String!
    type: CommentType!
    body: [SlateNode!]!
  }

  input UpdateCommentInput {
    id: String!
    type: CommentType!
    body: [SlateNode!]!
  }

  input ReactionInput {
    commentId: String!
    type: ReactionType!
    checked: Boolean!
  }

  enum AfterUpsertAnswerAction {
    NONE
    APPROVE
    APPROVE_AND_PUBLISH
  }

  input AnswerInCreateQuestionInput {
    body: [SlateNode!]!
    primaryLinkId: String
    afterAction: AfterUpsertAnswerAction = NONE
  }

  input AnswerInUpdateQuestionInput {
    body: [SlateNode!]!
    primaryLinkId: String
  }

  input CreateQuestionInput {
    plexId: String!
    questionTemplateId: String
    text: String!
    isDraft: Boolean!
    labelIds: [String!]
    type: CardType!
    boardId: String
    positionInBoard: Int
    answer: AnswerInCreateQuestionInput
  }

  input UpdateQuestionInput {
    id: String!
    text: String!
    changeDraftToInternal: Boolean
    labelIds: [String!]
    boardId: String
    positionInBoard: Int
    answer: AnswerInUpdateQuestionInput
  }

  input CreateAnswerInput {
    questionId: String!
    body: [SlateNode!]!
    primaryLinkId: String
    afterAction: AfterUpsertAnswerAction = NONE
  }

  input UpdateAnswerInput {
    id: String!
    body: [SlateNode!]!
    primaryLinkId: String
    afterAction: AfterUpsertAnswerAction = NONE
  }

  input AnswerReactionInput {
    answerId: String!
    type: ReactionType!
    checked: Boolean!
  }

  input AnswerApproval {
    answerId: String!
    checked: Boolean!
  }

  input PublishQuestionInput {
    questionId: String!
    checked: Boolean!
  }

  input QuestionReactionInput {
    questionId: String!
    type: ReactionType!
    checked: Boolean!
  }

  input PostReactionInput {
    postId: String!
    type: ReactionType!
    checked: Boolean!
  }

  input PublishPostInput {
    postId: String!
    checked: Boolean!
  }

  enum ItemType {
    POST
    QUESTION
  }

  input ShareInput {
    itemId: String!
    itemType: ItemType!
    channelId: String!
    channelType: ChannelType!
    note: String
  }

  input WatchPostPayload {
    postId: String!
    watching: Boolean!
  }

  input WatchQuestionPayload {
    questionId: String!
    watching: Boolean!
  }

  input BoardSourceInput {
    externalEntityId: String!
    headingIds: [String!]!
  }

  input CreateBoardInput {
    plexId: String!
    name: String!
    description: String

    source: BoardSourceInput
  }

  input UpdateBoardInput {
    name: String!
    description: String

    source: BoardSourceInput
  }

  input ChangeQuestionPositionInput {
    questionId: String!
    newPosition: Int!
  }

  input ChangeBoardPositionInput {
    boardId: String!
    newPosition: Int!
  }

  input ImportBoardFaqInput {
    faqId: String
    question: SlateNode!
    answer: [SlateNode!]!
  }

  input ImportBoardInput {
    plexId: String!
    boardName: SlateNode!
    importedQuestions: [ImportBoardFaqInput!]!
    externalEntityId: String!
  }

  input SyncBoardInput {
    boardId: String!
    boardName: SlateNode!
    importedQuestions: [ImportBoardFaqInput!]!
    externalEntityId: String!
  }

  input ImportFactInput {
    boardId: String!
    question: SlateNode!
    answer: [SlateNode!]!
    externalEntityId: String!
  }

  input CreateTaskInput {
    plexId: String!
    type: TaskType!
    publishStatus: PublishStatus!
    status: TaskStatus!
    dueDate: DateTime
    assigneeId: String
    title: String!
    body: [SlateNode!]!
    labelIds: [String!]
    sourceEntityRelation: SourceEntityRelationInput
  }

  input UpdateTaskInput {
    id: String!
    publishStatus: PublishStatus
    status: TaskStatus
    dueDate: DateTime
    assigneeId: String
    title: String
    body: [SlateNode!]
    labelIds: [String!]
  }

  input SourceEntityRelationInput {
    sourceType: EntityType!
    sourceId: String!
    type: EntityRelationType!
  }

  enum OnboardingStep {
    GET_STARTED
    GET_PLUGGED_INTO_PLEX
    KNOW_EACH_OTHER
  }

  enum ChangeEventType {
    CREATE
    UPDATE
    DELETE
  }

  enum ChangeEventTargetType {
    POST
    QUESTION
    COMMENT
    ANSWER
    EVENT
    BOARD
  }

  type UploadFileResponse {
    plexAssetUrl: String!
  }

  union CreateOrUpdatePlexResponse = Plex | PlexInputError

  input CreateFactReviewProcessInput {
    plexId: String!
    factId: String!
    authorIds: [String!]!
    reviewerIds: [String!]!
    reviewableBy: DateTime
    reviewBy: DateTime!
  }

  input UpdateFactReviewProcessInput {
    id: String!
    authorIds: [String!]!
    reviewerIds: [String!]!
    reviewableBy: DateTime
    reviewBy: DateTime!
  }

  type FactReviewProcess {
    id: String!
    plexId: String!
    plex: Plex!
    factId: String!
    fact: Question!
    authorIds: [String!]!
    authors: [PlexRegisteredUser!]!
    reviewerIds: [String!]!
    reviewers: [PlexRegisteredUser!]!
    reviewableBy: DateTime
    reviewBy: DateTime!
    createdEntities: [EntityRelation!]!
  }

  type Mutation {
    subscribeToPlex(plexId: String!): PlexUserRelation
    leavePlex(plexId: String!): PlexUserRelation
    createPlex(plex: PlexInput!): CreateOrUpdatePlexResponse!
    updatePlex(id: String!, plex: PlexInput!): CreateOrUpdatePlexResponse!
    deletePlex(id: String!): Plex
    createPost(post: CreatePostInput!): Post
    updatePost(post: UpdatePostInput!): Post
    createEvent(event: CreateEventInput!): Post
    updateEvent(event: UpdateEventInput!): Post
    importEventFromGoogleCalendar(event: GoogleCalendarEventInput!): Post
    publishPost(publishPostInput: PublishPostInput!): Post
    deletePost(id: String!): Post
    createPostComment(comment: CreatePostCommentInput!): Post
    deletePostComment(id: String!): Comment
    reactToComment(reaction: ReactionInput!): Comment
    reactToQuestion(reaction: QuestionReactionInput!): Question
    reactToPost(reaction: PostReactionInput!): Post

    createBoard(board: CreateBoardInput!): Board
    createBoardFromTemplate(plexId: String!, templateId: String!, questionTemplateIds: [String!]!): Board!
    updateBoard(id: String!, board: UpdateBoardInput!): Board
    deleteBoard(id: String!, faqDestinationBoard: String!, deleteAllFaqs: Boolean!): Board
    importBoard(input: ImportBoardInput!): Board
    syncBoard(input: SyncBoardInput!): Board
    changeBoardPosition(input: ChangeBoardPositionInput!): BoardPositionUpdate!

    importFact(input: ImportFactInput!): Question!

    createQuestion(question: CreateQuestionInput!): Question
    updateQuestion(question: UpdateQuestionInput!): Question
    publishQuestion(publishQuestionInput: PublishQuestionInput!): Question
    deleteQuestion(id: String!): Question
    changeQuestionPosition(input: ChangeQuestionPositionInput!): QuestionPositionUpdate!
    createQuestionComment(comment: CreateQuestionCommentInput!): Question
    updateComment(comment: UpdateCommentInput!): Comment
    promoteCommentToAnswer(commentId: String!): Question!

    ignoreQuestionTemplate(plexId: String!, templateId: String!): Question

    createAnswer(answer: CreateAnswerInput!): Answer
    updateAnswer(answer: UpdateAnswerInput!): Answer
    reactToAnswer(answer: AnswerReactionInput!): Answer
    approveAnswer(answerApproval: AnswerApproval!): Question
    deleteAnswer(id: String!): Answer

    createLabel(name: String!): Label

    share(shareInput: ShareInput!): ShareResponse

    updateUserSettings(userSettingsInput: UserSettingsInput!): User
    updateDomainUser(userId: String!, status: UserStatus, accessControl: AccessControlEnum): PlexRegisteredUser

    seenUserNotifications(postsIds: [String!]!, faqsIds: [String!]!): [FeedNotification!]
    seenNotificationActivity(id: String!): NotificationActivity
    deleteNotificationActivity(id: String!): NotificationActivity

    watchPost(payload: WatchPostPayload!): Post
    watchQuestion(payload: WatchQuestionPayload!): Question

    syncFromGoogleDocToPost(documentId: String!, postId: String!): Post!

    linkGoogleCalendar(plexId: String!, googleCalendarId: String!): Plex!
    unlinkGoogleCalendar(plexId: String!, googleCalendarId: String!): Plex!

    updatePaymentMethod(paymentMethodId: String, billingEmail: String, billingAddress: String): Domain!

    uploadFile(url: String!): UploadFileResponse!

    createTask(task: CreateTaskInput!): Task!
    updateTask(task: UpdateTaskInput!): Task!
    deleteTask(id: String!): Task!

    createEntityRelation(input: EntityRelationInput!): EntityRelation!
    deleteEntityRelation(entityRelationId: String!): EntityRelation!

    analyticsQuestionClick(id: String!): Boolean
    analyticsQuestionImpression(id: String!): Boolean
    analyticsPostClick(id: String!): Boolean
    analyticsPostImpression(id: String!): Boolean

    createFactReviewProcess(input: CreateFactReviewProcessInput!): FactReviewProcess!
    updateFactReviewProcess(input: UpdateFactReviewProcessInput!): FactReviewProcess!
  }

  type Subscription {
    board(plexIds: [String!]!): Board!
    posts(filters: PostFilters!): Post!
    comment(id: String!, isPost: Boolean!): Comment
    question(boardId: String!, filterPublishStatus: FilterPublishStatus!, labelIds: [String!]!): Question
    questionPosition(boardId: String!): QuestionPositionUpdate!
    answer(questionId: String!): Answer
    userNotifications: NotificationSubscriptionPayload!
    notificationActivity: NotificationActivity!
  }
`;
//# sourceMappingURL=index.js.map